import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyAnJtI9cN9eXMZhbwR9jj0Ur3g3EwKWAYM",
    authDomain: "blogprecisiongrow.firebaseapp.com",
    projectId: "blogprecisiongrow",
    storageBucket: "blogprecisiongrow.firebasestorage.app",
    messagingSenderId: "653985927403",
    appId: "1:653985927403:web:acbabc347c7e67ac8c2eae",
    measurementId: "G-WCHWKKW29N"
  };

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);